
import { ContactDetails, PersonalInfo } from '@/store/dueDiligence/types';
import { CountryCodes, OpenAccountMetadataOption } from '@/store/openAccount/types';
import { countryCodesList, getFormattedMobileNo, getStoredMobileNo, lookupCountryCode } from '@/utils/countryCodes';
import { CPTextInput } from '@capital-platforms/cpui';
import CPOptionDropdownAdapter from '@/components/globals/adapters/CPOptionDropdownAdapter.vue'
import Vue from 'vue';
import { Component, InjectReactive, Prop } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';

@Component({
    components: {
        CPTextInput,
        CPOptionDropdownAdapter,
        CPOpenAccountFormSubsection
    }
})
export default class CPDueDiligenceAccountHolderContactDetails extends Vue {
    @Prop({ required: true }) contactDetails!: ContactDetails;
    @InjectReactive() readonly viewOnly!: boolean;

    countryCodesList = countryCodesList;
    selectedCountryCode: string | null = lookupCountryCode(this.contactDetails.MobileNo || '') ?? null;
    mobileNo: string = getFormattedMobileNo(this.contactDetails.MobileNo || '');
    initialMobileNo: string | null = null;

    countryCodeAdapter(item: CountryCodes): OpenAccountMetadataOption<string> {
        return {
            value: item.value,
            text: item.text,
            metadata: {},
            Description: item.name
        };
    }

    syncToStored() {
        const stored = getStoredMobileNo(this.mobileNo || '');
        this.$set(this.contactDetails, 'MobileNo', stored);
    }

    handleCountryCodeInput(countryCode: string | null) {
        if (!countryCode) {
            return;
        }

        this.selectedCountryCode = countryCode;
        if (!this.mobileNo) {
            this.mobileNo = `${countryCode}-`;
            this.syncToStored();
            return;
        }

        if (this.mobileNo.includes('-')) {
            this.mobileNo = `${countryCode}-${this.mobileNo.split('-')[1] || ''}`;
        } else {
            this.mobileNo = getFormattedMobileNo(this.mobileNo);
        }

        this.syncToStored();
    }

    handleMobileNoInput(mobileNo: string | null) {
        this.mobileNo = mobileNo || '';
        this.syncToStored();
    }

    mounted() {
        this.initialMobileNo = this.contactDetails.MobileNo;
    }

    beforeDestroy() {
        if (this.contactDetails.MobileNo) return;
        this.$set(this.contactDetails, 'MobileNo', this.initialMobileNo);     
    }
}
